import { Skeleton, Stack } from "@mui/material";
import FullScreenInit from "components/FullScreenInit";
import { usePtcldScriptContext } from "contexts/PtcldScriptContext";
import { useRef, useEffect, useMemo, useState } from "react";
import * as THREE from "three";
import PointCloudView from "containers/PointCloudViewer/components/PointCloudView";
import { useGetOutputPointcloud } from "api/output/queries/useGetOutputPointcloud";
import { useParams, useSearchParams } from "react-router-dom";
import PCLDViewerHeader from "./PointCloudViewerHeader";
import { useGetOutputQuery } from "api/output/queries/useGetOutputQuery";
import { getHTTPFileUrlFromS3Path, getHTTPUrlFromS3Path } from "utils/outputs";
import { useGetScanTransformationQuery } from "api/scan/queries/useGetScanTransformationQuery";
import { useLoading } from "contexts/LoadingContext";
import { Bounce, toast } from "react-toastify";
import BlurryOverlay from "components/BlurryOverlay";
import { useGetVirtualTourReferenceMeasurements } from "api/virtual-tour/queries/useGetVirtualTourReferenceMeasurements";
import { getMiniMapSize, STATE_SELECTION } from "utils/potree";
import { getPotreeCameraAtom } from "store/atoms/potree/getPotreeCamera";
import { isPotreeFocuesAtom } from "store/atoms/potree/isPotreeFocusedAtom";
import { setPoreeCameraAtom } from "store/atoms/virtualTourViewer/setPotreeCameraAtom";
import { useAtom } from "jotai";

function PointCloudViewerContent() {
  const {
    scriptsLoaded,
    scriptError,
    setIfcLoading,
    error,
    setError,
    setIsSplit,
    isSplit,
    width,
    setIsIfcAvailable,
    setIsObjAvailable,
  } = usePtcldScriptContext();
  const {
    setLoading: setPointcloudLoading,
    setProgress: setLoadingProgression,
    blurryEffect,
    ptcldOutputId1,
    vtourOutputId1,
    scan1,
    scan1Data,
  } = useLoading();
  const [queryParams] = useSearchParams();
  const scan1FromQP = queryParams.get("scan1") || "";
  const scanFromQP = queryParams.get("scan") || "";
  const { scanId: scanIdFromP = "" } = useParams();

  const scanId = scanIdFromP || scan1FromQP || scanFromQP;

  const potreeContainerDiv = useRef<HTMLDivElement>(null);
  const viewerRef = useRef<Potree.Viewer | null>(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const selectionQuery = searchParams.get("selection");

  const [getPotreeCamera, setgetPotreeCamera] = useAtom(getPotreeCameraAtom);
  const [isPotreeFocused, setIsPotreeFocused] = useAtom(isPotreeFocuesAtom);
  const [isPotreeCameraSetString, setPotreeCameraString] =
    useAtom(setPoreeCameraAtom);
  const [currentView, setCurrentView] = useState<any>(null);
  const {
    data: pointCloudData,
    isLoading: dataLoading,
    error: dataError,
  } = useGetOutputPointcloud(ptcldOutputId1);
  const { data: output } = useGetOutputQuery(ptcldOutputId1);
  const { data: scanTransformation } = useGetScanTransformationQuery(
    scan1 || ""
  );
  const {
    data: vtouroutput,
    isLoading: outputLoading,
    error: outputError,
  } = useGetOutputQuery(vtourOutputId1);
  const { data: referenceMeasurements } =
    useGetVirtualTourReferenceMeasurements(vtouroutput?.virtualTour?.id || "");
  const scaleFactor = useMemo(() => {
    if (!referenceMeasurements || referenceMeasurements.length === 0) return 0;

    const avgScaleFactor = referenceMeasurements.reduce(
      (prev, current) => prev + (current.metadata?.scaleFactor ?? 0),
      0
    );

    return avgScaleFactor / referenceMeasurements.length;
  }, [referenceMeasurements]);

  // const {
  //   data: projectScanTransformation,
  //   isLoading: projectScanTransformationLoading,
  //   error: projectScanTransformationError,
  // } = useGetScanTransformationRelativeToProjectQuery(scanId);

  // console.log(projectScanTransformation);
  const outputUrl = output?.s3Path
    ? getHTTPUrlFromS3Path(output.s3Path).replace(
        "pointcloud/",
        "virtualtour/"
      ) + "vtour/"
    : "";
  const transformJsonUrl = outputUrl + "transforms_sparse_octree_textured.json";
  const getTransformJson = async () =>
    await (await fetch(transformJsonUrl)).json();
  const thumbnailUrl = outputUrl + "thumbnail.png";

  const objUrl = useMemo(() => {
    if (scan1Data?.referenceFloorPlanAlignedObjURL) {
      setIsObjAvailable(true);
    }
    return scan1Data?.referenceFloorPlanAlignedObjURL;
  }, [scan1Data]);
  const floorImageUrl = useMemo(() => {
    return scan1Data?.referenceFloorPlanAlignedImageURL;
  }, [scan1Data]);
  let currentFocuedImage: null | any;

  function calculateDistance(
    x: number,
    x1: number,
    y: number,
    y1: number,
    z: number,
    z1: number
  ): number {
    //   console.log("We are calling calculate distance "+Math.sqrt(
    //     Math.pow(x1 - x, 2) +
    //     Math.pow(y1 - y, 2) +
    //     Math.pow(z1 - z, 2)
    // ));
    return Math.sqrt(
      Math.pow(x1 - x, 2) + Math.pow(y1 - y, 2) + Math.pow(z1 - z, 2)
    );
  }
  useEffect(() => {
    return () => {
      setIsPotreeFocused(null);
      setCurrentView(null);
      setgetPotreeCamera(null);
    };
  }, []);

  useEffect(() => {
    //
    //console.log("this is the getPotreeCamera",getPotreeCamera ,isPotreeCameraSet);
    if (isPotreeCameraSetString) {
      //console.dir(getPotreeCamera);
      //console.dir(currentView?.scene?.view);
      //console.dir(isPotreeCameraSet);
      //console.log("this is the position of the camera "+getPotreeCamera.position.x+ " "+getPotreeCamera.position.y+" "+getPotreeCamera.position.z);
      // console.log(
      //   "This is the rotation of the camera: " +
      //     getPotreeCamera.rotation.x* (180 / Math.PI)+ " " +
      //     getPotreeCamera.rotation.y * (180 / Math.PI)+ " " +
      //     getPotreeCamera.rotation.z* (180 / Math.PI) +" "+isPotreeCameraSet.rotation.y
      // );
      let isPotreeCameraSet = JSON.parse(isPotreeCameraSetString);

      const m = isPotreeCameraSet.transformationMatrix; // your object
      const matrixArray = [
        m.e00,
        m.e10,
        m.e20,
        m.e30,
        m.e01,
        m.e11,
        m.e21,
        m.e31,
        m.e02,
        m.e12,
        m.e22,
        m.e32,
        m.e03,
        m.e13,
        m.e23,
        m.e33,
      ];

      const transformationMatrix = new THREE.Matrix4().fromArray(matrixArray);
      //console.log("this is the transformation matrix ",transformationMatrix);
      const conversion = new THREE.Matrix4();
      conversion.set(1, 0, 0, 0, 0, 0, -1, 0, 0, 1, 0, 0, 0, 0, 0, 1);

      // Compute the inverse of the conversion matrix
      const conversionInv = conversion.clone().invert();

      // Compose: M' = C * M * C⁻¹
      const result = conversion
        .clone()
        .multiply(transformationMatrix)
        .multiply(conversionInv);

      // Use the transformed position for the camera
      const decomposedPosition = new THREE.Vector3();
      const decomposedQuaternion = new THREE.Quaternion();
      const decomposedScale = new THREE.Vector3();

      result.decompose(
        decomposedPosition,
        decomposedQuaternion,
        decomposedScale
      );
      //console.log(decomposedPosition, decomposedQuaternion, decomposedScale);
      const euler = new THREE.Euler();
      euler.setFromQuaternion(decomposedQuaternion, "YZX"); // or your desired order

      const degX = THREE.MathUtils.radToDeg(euler.x);
      const degY = THREE.MathUtils.radToDeg(euler.y);
      const degZ = THREE.MathUtils.radToDeg(euler.z);

      // Apply your transformation
      const newDegX = 90 - degX;
      const newDegY = degY;
      const newDegZ = 180 - degZ;

      // Convert back to radians
      const newEuler = new THREE.Euler(
        THREE.MathUtils.degToRad(newDegX),
        THREE.MathUtils.degToRad(newDegY),
        THREE.MathUtils.degToRad(newDegZ),
        "YZX" // Same order as before
      );

      // Convert back to quaternion
      const newQuaternion = new THREE.Quaternion().setFromEuler(newEuler);
      // Set the camera position
      if (isPotreeCameraSet.isFocused == false)
        currentView?.changeCamera(
          -decomposedPosition.x,
          decomposedPosition.y,
          decomposedPosition.z,
          0.05 // or your desired value
        );

      // Set the camera rotation
      currentView?.changeRotation(
        newQuaternion.x,
        newQuaternion.y,
        newQuaternion.z,
        newQuaternion.w,
        0.05, // or your desired value
        isPotreeCameraSet.isFocused // or your desired value
      );
      console.log("This is the fov of the camera " + isPotreeCameraSet.fov);
      currentView?.changeFov(isPotreeCameraSet.fov);
      if (isPotreeCameraSet.isFocused == true) {
        let closestImage: any | null;
        let minDistance = Infinity;
        //console.log("images ",isPotreeFocused?.images);
        isPotreeFocused?.images.forEach((image: any) => {
          const distance = calculateDistance(
            -decomposedPosition.x,
            image.position[0],
            decomposedPosition.y,
            image.position[1],
            decomposedPosition.z,
            image.position[2]
          );

          if (distance < minDistance) {
            minDistance = distance;
            closestImage = image;
          }
        });
        if (
          isPotreeFocused?.focusedImage == null ||
          isPotreeFocused?.focusedImage !== closestImage
        ) {
          isPotreeFocused?.unfocus();
          //console.dir(currentView?.view);

          isPotreeFocused?.focus(closestImage);
        }
      } else {
        if (isPotreeFocused?.focusedImage != null) isPotreeFocused?.unfocus();
      }
    }
  }, [isPotreeCameraSetString, currentView, isPotreeFocused, getPotreeCamera]);
  let matrix: number[][] = [];
  useEffect(() => {
    //setgetPotreeCamera(null);
    const viewerElem = potreeContainerDiv.current;
    setLoadingProgression(0);
    if (!blurryEffect) {
      setPointcloudLoading(true);
    }
    let pointcloud: Potree.PointCloud | null = null;
    if (scriptsLoaded && pointCloudData) {
      // setPointcloudLoading(true); // eralier doing this but creating fluctation
      const Potree = window.Potree;
      const proj4 = window.proj4;
      if (!Potree) {
        setError("Potree library not found.");
        console.error("Potree library not found.");
        setPointcloudLoading(false);
        return;
      }
      if (viewerElem) {
        viewerRef.current = new Potree.Viewer(viewerElem);
        viewerRef.current.controls.enabled = false;
        const camera = viewerRef.current?.scene.cameraP;
        setCurrentView(viewerRef.current);
        //console.dir(camera);
        setgetPotreeCamera(camera);
        //console.dir(getPotreeCamera);
        if (scanTransformation) {
          matrix = scanTransformation.scanWrtWorld;
        }
        const Image360 = async (coordinatesUrl: string, imageUrl: string) => {
          try {
            if (viewerRef.current) {
              proj4.defs(
                "WGS84",
                "+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs"
              );
              proj4.defs("pointcloud", viewerRef.current.getProjection());
              const transform = proj4("WGS84", "pointcloud");

              const params = {
                transform: transform,
              };

              // Load 360 images
              Potree.Images360Loader.load(
                coordinatesUrl,
                viewerRef.current,
                imageUrl,
                params,
                matrix
              ).then((images) => {
                console.log("Loaded 360 images");
                if (viewerRef.current) {
                  viewerRef.current.scene.add360Images(images);
                  //viewerRef.current.setControls(null);
                  setIsPotreeFocused(viewerRef.current?.scene?.images360[0]);
                  //console.dir(viewerRef.current?.scene?.images360[0]);
                  //   setInterval(() => {
                  //     //viewerRef.current?.scene.cameraP.position.set(x, y, z);
                  //    viewerRef.current?.changeCamera(x,y,z);
                  //  }, 3000);
                }
              });
            }
          } catch (err) {
            console.error("Error in run function:", err);
          }
        };

        const OrientedImage = async (
          coordinatesUrl: string,
          imageUrls: { [key: string]: string | null },
          xmlfile: string
        ) => {
          try {
            // Load oriented images
            if (viewerRef.current) {
              Potree.OrientedImageLoader.load(
                xmlfile,
                coordinatesUrl,
                viewerRef.current,
                imageUrls
              ).then((images) => {
                if (viewerRef.current) {
                  viewerRef.current.scene.addOrientedImages(images);
                }
              });
            }
          } catch (err) {
            console.error("Error in run function:", err);
          }
        };

        try {
          if (viewerRef.current) {
            viewerRef.current.setEDLEnabled(true);
            viewerRef.current.setFOV(60);
            viewerRef.current.setPointBudget(1 * 1000 * 1000);
            viewerRef.current.setClipTask(Potree.ClipTask.HIGHLIGHT);
            viewerRef.current.loadSettingsFromURL();
            viewerRef.current.setBackground("black");

            viewerRef.current.setControls(viewerRef.current.orbitControls);

            viewerRef.current.loadGUI(() => {
              if (viewerRef.current) {
                viewerRef.current.setLanguage("en");
                const menuAppearance =
                  document.getElementById("menu_appearance");
                if (menuAppearance && menuAppearance.nextElementSibling) {
                  const sibling =
                    menuAppearance.nextElementSibling as HTMLElement;
                  sibling.style.display = "block";
                } else {
                  console.error("Next sibling of #menu_appearance not found.");
                }
              }
            });

            const url = getHTTPFileUrlFromS3Path(pointCloudData.metadata);
            const hierarchyUrl = getHTTPFileUrlFromS3Path(
              pointCloudData.hierarchy
            );
            const octreeUrl = getHTTPFileUrlFromS3Path(pointCloudData.octree);
            const otherPath = {
              octree: octreeUrl,
              hierarchy: hierarchyUrl,
            };

            Potree.loadPointCloud(url, otherPath, matrix).then(
              (e) => {
                if (viewerRef.current) {
                  if (
                    objUrl &&
                    floorImageUrl &&
                    scan1Data?.scanTransformation?.referenceFloor?.metadata
                  ) {
                    viewerRef.current.setFloorPlan(
                      floorImageUrl,
                      {
                        x: scan1Data.scanTransformation?.referenceFloor
                          ?.metadata?.obj?.centerX,
                        y: scan1Data.scanTransformation?.referenceFloor
                          ?.metadata?.obj?.centerY,
                      },
                      scan1Data.scanTransformation?.referenceFloor?.metadata
                        ?.obj?.lengthX,
                      scan1Data.scanTransformation?.referenceFloor?.metadata
                        ?.obj?.lengthY
                    );
                    viewerRef.current.miniMapPosition(
                      undefined,
                      10,
                      getMiniMapSize(),
                      floorImageUrl,
                      {
                        x: scan1Data.scanTransformation?.referenceFloor
                          ?.metadata?.obj?.centerX,
                        y: scan1Data.scanTransformation?.referenceFloor
                          ?.metadata?.obj?.centerY,
                      },
                      scan1Data.scanTransformation?.referenceFloor?.metadata
                        ?.obj?.lengthX,
                      scan1Data.scanTransformation?.referenceFloor?.metadata
                        ?.obj?.lengthY
                    );
                    viewerRef.current.floorPlanEnabled = true;
                    viewerRef.current.thumbnailEnabled = false;
                  }
                  getTransformJson()
                    .then((data) => {
                      if ("thumbnail" in data) {
                        console.log("Thumbnail data exists:", data.thumbnail);
                        viewerRef.current?.setThumbnail(
                          thumbnailUrl,
                          {
                            x: data.thumbnail.center[0],
                            y: data.thumbnail.center[1],
                          },
                          data.thumbnail.width,
                          data.thumbnail.height
                        );
                        if (viewerRef.current && !viewerRef.current?.floorPlanEnabled) {
                          try {
                            viewerRef.current?.miniMapPosition(
                              undefined,
                              10,
                              getMiniMapSize(),
                              thumbnailUrl,
                              {
                                x: data.thumbnail.center[0],
                                y: data.thumbnail.center[1],
                              },
                              data.thumbnail.width,
                              data.thumbnail.height
                            );
                            viewerRef.current.thumbnailEnabled = true;
                            viewerRef.current.floorPlanEnabled = false;
                          } catch (e) {
                            console.error(
                              "Error setting minimap image in Potree:",
                              e
                            );
                          }
                        }
                      } else {
                        console.log("No thumbnail data found in JSON");
                      }
                    })
                    .catch((error) =>
                      console.error("Error fetching transform JSON:", error)
                    );

                  pointcloud = e.pointcloud;
                  pointcloud.name = "ptcld";
                  const material = pointcloud.material;

                  material.activeAttributeName = "rgba";
                  material.minSize = 2;
                  material.size = 0.5;
                  material.pointSizeType = Potree.PointSizeType.ADAPTIVE;
                  if (scaleFactor && scaleFactor !== 0) {
                    viewerRef.current.setExternalMeasureScale(scaleFactor);
                  }
                  viewerRef.current.scene.addPointCloud(pointcloud);
                  viewerRef.current.fitToScreen();
                  viewerRef.current.setPointBudget(5_000_000);
                  // viewerRef.current.useHQ = true;

                  // 360 images check
                  if (
                    pointCloudData.coordinates360 &&
                    pointCloudData.vtImage360Path
                  ) {
                    const coordinates360path = getHTTPFileUrlFromS3Path(
                      pointCloudData.coordinates360
                    );
                    const images360path = getHTTPUrlFromS3Path(
                      pointCloudData.vtImage360Path
                    );
                    Image360(coordinates360path, images360path);
                    viewerRef.current.setClassifications(
                      Potree.ClassificationScheme.PREIMAGE
                    );
                  }

                  // Oriented/simple images check
                  if (
                    pointCloudData.coordinatesOriented &&
                    pointCloudData.xmlfile &&
                    pointCloudData.imageOriented
                  ) {
                    OrientedImage(
                      pointCloudData.coordinatesOriented,
                      pointCloudData.imageOriented,
                      pointCloudData.xmlfile
                    );
                  }

                  // viewerRef.current.mapView.showSources(false);
                  setLoadingProgression(100);
                }
              },
              (e) => {
                console.error("ERROR loading point cloud:", e);
                setPointcloudLoading(false);
              }
            );

            if (pointCloudData.ifc) {
              setIfcLoading(true);
              const ifc = new Potree.IFC(viewerRef.current);
              const ifcUrl = getHTTPFileUrlFromS3Path(pointCloudData.ifc);
              ifc
                .load(ifcUrl, viewerRef.current.scene, "ifc", true, matrix)
                .then((mesh: unknown) => {
                  // mesh: unknown
                  {
                    setIfcLoading(false);
                  }
                });
            }

            // Potree.loadPointCloud(url, otherPath).then(
            //   (e) => {
            //     if (viewerRef.current) {
            //       const pointcloud = e.pointcloud;
            //       pointcloud.name = "split-ptcld";
            //       pointcloud.visible = false;
            //       const material = pointcloud.material;

            //       material.activeAttributeName = "rgba";
            //       material.minSize = 2;
            //       material.pointSizeType = Potree.PointSizeType.FIXED;

            //       viewerRef.current.scene2.addPointCloud(pointcloud);
            //       viewerRef.current.fitToScreen();
            //       viewerRef.current.mapView.showSources(false);
            //       setPointcloudLoading(false);
            //     }
            //   },
            //   (e) => {
            //     console.error("ERROR loading point cloud:", e);
            //     setPointcloudLoading(false);
            //   }
            // );
          }
        } catch (err) {
          setError("Failed to initialize Potree viewer.");
          console.error("Error loading point cloud:", err);
          setPointcloudLoading(false);
        }
      }
    }
    return () => {
      document
        .querySelectorAll(".sp-container, .ui-slider, .i18n-container")
        .forEach((element) => {
          element.remove();
        });

      if (pointcloud) {
        Potree.cleanupPotree(pointcloud);
      }

      if (viewerRef.current) {
        console.log("Viewer ref exists, clearing it", viewerRef.current);
        viewerRef.current.renderer.clear();
        viewerRef.current = null;

        const profileWindow = document.getElementById("profile_window");
        if (profileWindow && profileWindow.parentNode) {
          profileWindow.parentNode.removeChild(profileWindow);
        }
      }
    };
  }, [pointCloudData, scriptsLoaded]);
  useEffect(() => {
    if (selectionQuery === STATE_SELECTION.ifc) {
      if (
        viewerRef.current?.scene2?.ifc?.length &&
        viewerRef.current.scene2.ifc.length > 0
      )
        return;
      if (pointCloudData?.ifc && viewerRef.current) {
        const toastId = toast.loading("Loading IFC...", {
          position: "bottom-right",
          style: { width: "auto" },
          transition: Bounce,
        });
        const ifc = new Potree.IFC(viewerRef.current);
        const ifcUrl = getHTTPFileUrlFromS3Path(pointCloudData.ifc);
        ifc
          .load(ifcUrl, viewerRef.current.scene2, "split-ifc", true, matrix)
          .then((mesh: unknown) => {
            toast.dismiss(toastId);
            console.log("IFC loaded", mesh);
          });
      }
    } else if (selectionQuery === STATE_SELECTION.obj) {
      if (
        viewerRef.current?.scene2?.obj?.length &&
        viewerRef.current.scene2.obj.length > 0
      )
        return;
      if (viewerRef.current && objUrl && floorImageUrl) {
        // pointCloudData?.ifc && viewerRef.current
        const toastId = toast.loading("Loading Floor Plan...", {
          position: "bottom-right",
          style: { width: "auto" },
          transition: Bounce,
        });
        const objLoader = new Potree.OBJModelLoader(viewerRef.current);
        // getHTTPFileUrlFromS3Path(pointCloudData.ifc)
        objLoader
          .load(
            objUrl,
            floorImageUrl,
            viewerRef.current?.scene,
            "floor",
            matrix
          )
          .then((object: Potree.Obj) => {
            console.log("floor plan loaded", object);
          })
          .catch((error: any) => {
            console.error("Error loading floor plan:", error);
          });

        objLoader
          .load(
            objUrl,
            floorImageUrl,
            viewerRef.current?.scene2,
            "split-floor",
            matrix
          )
          .then((object: Potree.Obj) => {
            toast.dismiss(toastId);
            console.log("floor plan loaded", object);
          })
          .catch((error: any) => {
            toast.dismiss(toastId);
            console.error("Error loading floor plan:", error);
          });
      }
    }
  }, [selectionQuery, viewerRef.current]);

  if (dataError || error || scriptError) {
    return toast.error(error || scriptError || dataError?.message, {
      position: "bottom-left",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      transition: Bounce,
    });
  }

  return (
    <Stack height="100%" direction="column" gap={{ xs: 0.5, sm: 1 }}>
      {/* {!fullScreen && (
        <PCLDViewerHeader />
      )} */}
      <PointCloudView
        potreeContainerDiv={potreeContainerDiv}
        viewerRef={viewerRef}
      />
    </Stack>
  );
}

export default PointCloudViewerContent;
